module.exports = __webpack_public_path__ + "img/full3-min.910abb27.png";